export default __webpack_public_path__ + "static/media/homeSliderTruck.0c01b0b6.jpg";